import { render, staticRenderFns } from "./NavFooter.vue?vue&type=template&id=5f935273&scoped=true&"
import script from "./NavFooter.vue?vue&type=script&lang=js&"
export * from "./NavFooter.vue?vue&type=script&lang=js&"
import style0 from "./NavFooter.vue?vue&type=style&index=0&id=5f935273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f935273",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFooter,VIcon})
